package org.example.project.enginekalender

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import org.example.project.utils.All
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun EngineMonthCalendar(
    selectedDate: String,
    onSelectDate: (String) -> Unit,
    bookings: List<All> = emptyList(),
    showHeader: Boolean = true,
    showFooter: Boolean = false,
    useWeekBorderLayout: Boolean = true,
    showSelectedDayBorder: Boolean = true,
    cellSizePx: Int = 36,
    gapPx: Int = 6,
    weekdayHeightPx: Int = 18,
    fontSizePx: Int = 12,
    borderRadiusPx: Int = 12
) {
    val initialCursor = selectedDate.takeIf { it.matches(Regex("\\d{4}-\\d{2}-\\d{2}")) } ?: kalenderTodayIsoDate()
    var monthCursor by remember { mutableStateOf(initialCursor) }
    LaunchedEffect(selectedDate.take(7)) {
        monthCursor = selectedDate
    }
    val monthData = remember(monthCursor, selectedDate) { buildKalenderMonthData(selectedDate, monthCursor) }
    val dayStatesByDate = remember(bookings) {
        bookings.groupBy { it.datum }.mapValues { (_, dayBookings) -> kalenderDayState(dayBookings) }
    }

    KalenderMiniContainer {
        if (showHeader) {
            Div({
                style {
                    width(100.percent)
                    maxWidth(100.percent)
                    display(DisplayStyle.Flex)
                    justifyContent(JustifyContent.SpaceBetween)
                    alignItems(AlignItems.Center)
                    gap(8.px)
                    marginBottom(4.px)
                }
            }) {
                calendarNavButton("images/left.svg") {
                    monthCursor = monthData.previousMonthIso
                }
                Span({
                    style {
                        fontSize(14.px)
                        fontWeight("700")
                        color(Color.white)
                        textAlign("center")
                        flexGrow(1)
                    }
                }) { Text(monthData.bezeichnung) }
                calendarNavButton("images/right.svg") {
                    monthCursor = monthData.nextMonthIso
                }
            }
        }

        if (useWeekBorderLayout) {
            KalenderMiniWeekBorderLayout(
                monthData = monthData,
                selectedDate = selectedDate,
                onSelectDate = {
                    onSelectDate(it)
                    monthCursor = it
                },
                dayStatesByDate = dayStatesByDate,
                showSelectedDayBorder = showSelectedDayBorder,
                cellSizePx = cellSizePx,
                gapPx = gapPx,
                weekdayHeightPx = weekdayHeightPx,
                fontSizePx = fontSizePx,
                borderRadiusPx = borderRadiusPx
            )
        } else {
            KalenderMiniDayBorderLayout(
                monthData = monthData,
                selectedDate = selectedDate,
                onSelectDate = {
                    onSelectDate(it)
                    monthCursor = it
                },
                dayStatesByDate = dayStatesByDate,
                showSelectedDayBorder = showSelectedDayBorder,
                cellSizePx = cellSizePx,
                gapPx = gapPx,
                weekdayHeightPx = weekdayHeightPx,
                fontSizePx = fontSizePx,
                borderRadiusPx = borderRadiusPx
            )
        }

        if (showFooter) {
            Span({ style { color(Color("#9aa4b5")); fontSize(12.px) } }) {
            Text("Heute: ${kalenderTodayIsoDate()}  |  Ausgewählt: $selectedDate")
            }
        }
    }
}

@Composable
private fun calendarNavButton(icon: String, onClickAction: () -> Unit) {
    Button(attrs = {
        style {
            width(34.px)
            height(34.px)
            padding(0.px)
            borderRadius(10.px)
            property("background", "rgba(255,255,255,0.10)")
            property("border", "1px solid rgba(255,255,255,0.18)")
            color(Color.white)
            cursor("pointer")
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Center)
        }
        onClick { onClickAction() }
    }) {
        Img(src = icon, attrs = {
            style {
                width(14.px)
                height(14.px)
                property("filter", "brightness(0) invert(1)")
            }
        })
    }
}
